<template>
  <section
    class="final-cta-form py-5 bg-gradient-primary text-white
   position-relative overflow-hidden"
  >
    <div class="container text-center py-4 position-relative z-index-2">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <span
            class="badge badge-light text-dark-blue
          font-weight-bold px-3 py-2 text-uppercase mb-3 shadow-xs"
          >
            🚀 El Siguiente Paso en tu Carrera
          </span>
          <h2 class="display-4 font-weight-bold mb-3">
            Recupera tu tiempo y dale un salto de calidad a tu consulta médica.
          </h2>
          <p class="lead opacity-90 mb-4">
            Únete a los más de 500 profesionales que ya atienden a más
            pacientes con menos esfuerzo y mayor tranquilidad.
          </p>

          <div
            class="d-flex flex-column flex-sm-row
          align-items-center justify-content-center"
          >
            <a
              href="https://amii.app/soy-medico"
              class="btn btn-success-base btn-lg btn-pulse-success
              px-5 py-3 font-weight-bold rounded-lg shadow-lg
              text-white text-decoration-none"
              @click.prevent="$emit('start-register')"
            >
              Comenzar Mi Registro Gratis →
            </a>
          </div>

          <p class="x-small opacity-80 mt-3 mb-0">
            ✓ Registro en menos de 3 minutos | ✓ Asistencia en la
            configuración inicial
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FinalCtaForm',
};
</script>

<style scoped>
.text-dark-blue {
  color: #002196;
}
.bg-gradient-primary {
  background: linear-gradient(135deg, #002196 0%, #007BFF 100%);
}
.x-small {
  font-size: 0.8rem;
}
</style>
